<ng-container *ngIf="hayBeneficios">

  <div class="mc-hd">
    <h2>Tus beneficios como {{ nivel }}</h2>
    <a class="mc-more" [routerLink]="['/mis-beneficios']">Ver todos los beneficios</a>
  </div>

  <!-- Beneficios reales del Club, por pais y nivel. Ver shared/beneficios.ts -->
  <div class="br-bens">
    <div class="br-ben" *ngFor="let b of beneficios">
      <b *ngIf="b.destacado">{{ b.destacado }}</b>
      <div class="br-bt">
        <span>{{ b.texto }}</span>
      </div>
    </div>
  </div>

</ng-container>
